<template>
  <a-table
    :rowKey="record => record.staff_id"
    :columns="columns"
    :dataSource="processedData"
    :pagination="false"
    :loading="loading"
  >

   <template slot="staffCode" slot-scope="staff_code">
      <span><strong>{{ staff_code || '-' }}</strong></span>
    </template>

    <template slot="name" slot-scope="name">
      <span><strong>{{ name || '-' }}</strong></span>
    </template>

  <template slot="staffTitle" slot-scope="title">
      <span>{{ title || '-' }}</span>
    </template>

    <template slot="substitute" slot-scope="text, record">
      <a-input-number
        :min="0"
        :value="record.substitute_count"
        @change="value => onChange(record.staff_id, value)"
      />
    </template>
     <template slot="action" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title" v-if="record.substitute_count === record.original_substitute_count">
                <span>Change substitute count to enable update</span>
            </template>

                <a-button
                    v-if="rolesetting.editable"
                    type="primary"
                    class="mr-2"
                    :disabled="record.substitute_count === record.original_substitute_count"
                    @click="onSave(record)"
                >
                    <i class="fe fe-edit mr-1" />
                        Update Count
                </a-button>
            </a-tooltip>

            <!-- <a-tooltip placement="top">
  <template slot="title" v-if="record.substitute_count === 0">
    <span>Enter substitute count to enable delete</span>
  </template>

  <a-button
    v-if="rolesetting.deletable"
    type="danger"
    size="small"
    :disabled="record.substitute_count === 0"
    @click="onDelete(record)"
  >
    <i class="fe fe-trash mr-1" />
    Delete
  </a-button>
</a-tooltip> -->
        </template>
  </a-table>
</template>

<script>
const columns = [
  {
    title: 'Staff Code',
    dataIndex: 'staff_code',
    scopedSlots: { customRender: 'staffCode' },
  },
  {
    title: 'System Staff ID',
    dataIndex: 'system_staff_id',
  },
  {
    title: 'Staff Name',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'Staff Title',
    dataIndex: 'title',
    scopedSlots: { customRender: 'staffTitle' },
  },
  {
    title: 'Substitute Count',
    dataIndex: 'substitute_count',
    scopedSlots: { customRender: 'substitute' },
  },
  {
    title: 'Actions',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  props: {
    data: Array,
    loading: Boolean,
    rolesetting: {
      type: Object,
      default: () => ({
        editable: true,
        deletable: true,
      }),
    },
  },

  computed: {
    processedData() {
      return this.data
    },
  },

  data() {
    return { columns }
  },

  methods: {
    onChange(id, value) {
      this.$emit('updateSubstitute', { id, value })
    },
    onSave(record) {
      this.$emit('editStaff', record)
    },

    onDelete(record) {
      this.$emit('deleteStaff', record)
    },
  },
}
</script>
